import { FONT_WEIGHT } from '../../../foundations/typography';
import { TextVariantType } from '../../variants';
import { commonStyles } from '../commonStyles';
import { AccordionVariantType } from '../variants';
export const getAccordionWithToggleStyles = (FOUNDATIONS, FONT) => {
    return {
        [AccordionVariantType.ACCORDION_WITH_TOGGLE]: {
            ...commonStyles(FOUNDATIONS, FONT),
            container: {
                ...commonStyles(FOUNDATIONS, FONT).container,
                background_color: FOUNDATIONS.color_comp_containers_bg,
                border_radius: `${FOUNDATIONS.radius_250} ${FOUNDATIONS.radius_250} 0 0`,
            },
            subHeader: {
                margin_left: FOUNDATIONS.spacing_350,
                margin_top: '0.125rem',
            },
            title: {
                color: FOUNDATIONS.color_neutral_bg_onsurface_50,
                font_variant: TextVariantType.FONT_PARAGRAPH_250,
                font_weight: FONT_WEIGHT.font_bold,
            },
            headerInternalContainer: {
                padding: FOUNDATIONS.spacing_250,
            },
            content: {
                padding_left: FOUNDATIONS.spacing_350,
                padding_right: FOUNDATIONS.spacing_150,
                padding_bottom: FOUNDATIONS.spacing_100,
            },
        },
    };
};
//# sourceMappingURL=accordionWithToggle.js.map